import { CreatomateFont, BuiltInFontDefinition } from "./BuiltInFonts";

export const CreatomateMicrosoftFonts: CreatomateFont[] = [
  // Japanese
  {
    family: "Yu Gothic",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothic-Regular-01.ttf"
  },
  {
    family: "Yu Gothic UI Semilight",
    weight: 350,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothicUI-Semilight-02.ttf"
  },
  {
    family: "Yu Gothic Medium",
    weight: 500,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothic-Medium-01.ttf"
  },
  {
    family: "Yu Gothic UI",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothic-Regular-01.ttf"
  },
  {
    family: "Yu Gothic Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothic-Light-01.ttf"
  },
  {
    family: "Yu Gothic UI Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothicUI-Light-02.ttf"
  },
  {
    family: "Yu Gothic Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothic-Bold-01.ttf"
  },
  {
    family: "Yu Gothic UI Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothicUI-Bold-02.ttf"
  },
  {
    family: "Yu Gothic UI Semibold",
    weight: 600,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothicUI-Semibold-03.ttf"
  },
  // Chinese Traditional
  {
    family: "Microsoft JhengHei",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiRegular-01.ttf"
  },
  {
    family: "Microsoft JhengHei UI",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiUIRegular-02.ttf"
  },
  {
    family: "Microsoft JhengHei Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiBold-01.ttf"
  },
  {
    family: "Microsoft JhengHei UI Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiUIBold-02.ttf"
  },
  {
    family: "Microsoft JhengHei Light",
    weight: 290,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiLight-01.ttf"
  },
  {
    family: "Microsoft JhengHei UI Light",
    weight: 290,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiUILight-02.ttf"
  },
  // Chinese Simplified
  {
    family: "Microsoft Yahei",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHei-01.ttf"
  },
  {
    family: "Microsoft Yahei UI",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHeiUI-02.ttf"
  },
  {
    family: "Microsoft Yahei Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHei-Bold-01.ttf"
  },
  {
    family: "Microsoft Yahei UI Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHeiUI-Bold-02.ttf"
  },
  {
    family: "Microsoft Yahei Light",
    weight: 290,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHeiLight-01.ttf"
  },
  {
    family: "Microsoft Yahei UI Light",
    weight: 290,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHeiUILight-02.ttf"
  },
  {
    family: "Segoe Sans Display Semibold",
    weight: 600,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/microsoft-segoe-sans-display-semibold.ttf"
  },
  {
    family: "Segoe Sans Display Black",
    weight: 900,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/microsoft-segoe-sans-display-black.ttf"
  },
  {
    family: "Segoe Sans Display ExtraBold",
    weight: 800,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/microsoft-segoe-sans-display-extrabold.ttf"
  },
  {
    family: "Segoe Sans Display",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/microsoft-segoe-sans-display.ttf"
  }
];

export const BuiltInMicrosoftFonts: BuiltInFontDefinition[] = [
  // Japanese
  {
    family: "Yu Gothic",
    weights: [400],
    styles: ["normal"],
    category: "other",
    languages: [
      "ja"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothic-Regular-01.ttf"
  },
  {
    family: "Yu Gothic UI Semilight",
    weights: [350],
    styles: ["normal"],
    category: "other",
    languages: [
      "ja"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothicUI-Semilight-02.ttf"
  },
  {
    family: "Yu Gothic Medium",
    weights: [500],
    styles: ["normal"],
    category: "other",
    languages: [
      "ja"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothic-Medium-01.ttf"
  },
  {
    family: "Yu Gothic UI",
    weights: [400],
    styles: ["normal"],
    category: "other",
    languages: [
      "ja"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothic-Regular-01.ttf"
  },
  {
    family: "Yu Gothic Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    languages: [
      "ja"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothic-Light-01.ttf"
  },
  {
    family: "Yu Gothic UI Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    languages: [
      "ja"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothicUI-Light-02.ttf"
  },
  {
    family: "Yu Gothic Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    languages: [
      "ja"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothic-Bold-01.ttf"
  },
  {
    family: "Yu Gothic UI Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    languages: [
      "ja"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothicUI-Bold-02.ttf"
  },
  {
    family: "Yu Gothic UI Semibold",
    weights: [600],
    styles: ["normal"],
    category: "other",
    languages: [
      "ja"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Japanese/YuGothicUI-Semibold-03.ttf"
  },
  // Chinese Traditional
  {
    family: "Microsoft JhengHei",
    weights: [400],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-TW"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiRegular-01.ttf"
  },
  {
    family: "Microsoft JhengHei UI",
    weights: [400],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-TW"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiUIRegular-02.ttf"
  },
  {
    family: "Microsoft JhengHei Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-TW"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiBold-01.ttf"
  },
  {
    family: "Microsoft JhengHei UI Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-TW"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiUIBold-02.ttf"
  },
  {
    family: "Microsoft JhengHei Light",
    weights: [290],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-TW"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiLight-01.ttf"
  },
  {
    family: "Microsoft JhengHei UI Light",
    weights: [290],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-TW"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Traditional/MicrosoftJhengHeiUILight-02.ttf"
  },
  // Chinese Simplified
  {
    family: "Microsoft Yahei",
    weights: [400],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-CN"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHei-01.ttf"
  },
  {
    family: "Microsoft Yahei UI",
    weights: [400],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-CN"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHeiUI-02.ttf"
  },
  {
    family: "Microsoft Yahei Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-CN"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHei-Bold-01.ttf"
  },
  {
    family: "Microsoft Yahei UI Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-CN"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHeiUI-Bold-02.ttf"
  },
  {
    family: "Microsoft Yahei Light",
    weights: [290],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-CN"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHeiLight-01.ttf"
  },
  {
    family: "Microsoft Yahei UI Light",
    weights: [290],
    styles: ["normal"],
    category: "other",
    languages: [
      "zh", "zh-CN"
    ],
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/Chinese/Simplified/MicrosoftYaHeiUILight-02.ttf"
  },
  {
    family: "Segoe Sans Display Semibold",
    weights: [600],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/microsoft-segoe-sans-display-semibold.ttf"
  },
  {
    family: "Segoe Sans Display Black",
    weights: [490],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/microsoft-segoe-sans-display-black.ttf"
  },
  {
    family: "Segoe Sans Display ExtraBold",
    weights: [800],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/microsoft-segoe-sans-display-extrabold.ttf"
  },
  {
    family: "Segoe Sans Display",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/Microsoft/microsoft-segoe-sans-display.ttf"
  }
];
